import './active-dot.scss';

<template>
  <span class="component-active-dot" ...attributes></span>
</template>
